import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { AvailabilityStatus } from '@grpc-clients/external/mercury/v1/dining/dining.pb';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@shared/shared/helpers/base-component';
import { SiteConfigService } from '@shared/shared/services/site-config.service';

@Component({
  selector: 'ten-card-booking-cta',
  templateUrl: './card-booking-cta.component.html',
  styleUrls: ['./card-booking-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatLegacyButtonModule, TranslateModule, NgClass],
})
export class CardBookingCtaComponent extends BaseComponent {
  @Input() public availabilityStatus: number;
  public componentData: {
    layout: string;
  };

  constructor(siteConfService: SiteConfigService) {
    super(siteConfService, 'dining-search-results');
  }

  public checkAvailability(): string {
    if (this.availabilityStatus === AvailabilityStatus.AVAILABLE) {
      return 'DiningLandingPage:BookNowCTA';
    } else {
      return 'DiningLandingPage:RequestCTA';
    }
  }
}
